export default "__VITE_ASSET__B7siNVv3__"